import intlTelInput from 'intl-tel-input';
import { geoData } from './geo';

// this is the way intlTelInput checks for mobile
const isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const setupPhoneInput = async (input, { onCountryChange = () => null, appendToBodyInMobile = true } = {}) => {
  const { countryCode } = await geoData;

  // intlTelInput inserts the countries dropdown at the bottom of the page if isMobile
  // in order for focus-trap to work it needs the dropdown needs to be inside the form
  let dropdownContainer;
  if (isMobile && !appendToBodyInMobile) {
    dropdownContainer = input.parentElement;
  }

  const intlPhoneInput = intlTelInput(input, {
    separateDialCode: true,
    initialCountry: countryCode,
    dropdownContainer
  });

  input.intlPhoneInput = intlPhoneInput; // eslint-disable-line no-param-reassign

  input.addEventListener('countrychange', onCountryChange);

  return intlPhoneInput;
};
